<template>
  <div>
    <h1 class="mobiTitle white lg content" id="contentTitle">
      {{ $t('faq') }}
      
    </h1>
    
    <span v-if="country_code_cm == 'greece' && gateway_code =='mobivas'">
     
        <faq-paydash-greek/>
        
    </span>
       
  </div>
</template>

<script>
import FaqGRPaydashEnglish from './FaqGRPaydashEnglish';
import FaqGRPaydashGreek from './FaqGRPaydashGreek';

import { mapGetters } from "vuex";

export default {
  computed: mapGetters(["lang_cm", "country_cm","country_code_cm","gateway_code"]),
  components:{
    'faq-paydash-english': FaqGRPaydashEnglish,
    'faq-paydash-greek': FaqGRPaydashGreek,
    

  },
  methods: {
  }
};
</script>

<style scoped lang="scss">
.mobiFaq {
  margin: 25px 0px;
  .mobitxt {
    margin: 8px 0px;
    padding-left: 25px;
  }
  .mobiTitle {
    padding: 12px;
    background: #f1f1f1;
  }
  li {
    font-size: 1rem;
    line-height: 1.2;
    font-weight: 300;
    margin-bottom: 8px;
  }
}
.mobitxt a {
    
    color: black !important;
}
</style>


// WEBPACK FOOTER //
// src/components/cutemobi/Faq.vue